/*
 * FinviseDialog
 * Modal for the Finvise portal pages (Report register). Same visual
 * language as the page cards; the legacy GenericDialog is styled for the
 * dark app shell and looks out of place here.
 * `busy` shows a spinner (no buttons); `buttons` is [{ id, text }] and
 * `onButton` receives the clicked id.
 */
const FinviseDialog = ({ title, text, busy = false, buttons, onButton }) => (
	<>
		<div className='fv-modal-mask' />
		<div className='fv-modal' role='dialog' aria-modal='true' aria-live='polite'>
			{busy ? <span className='fv-modal-spinner' /> : null}
			<div className='fv-modal-title'>{title}</div>
			<div className='fv-modal-text'>{text}</div>
			{buttons && buttons.length ? (
				<div className='fv-modal-actions'>
					{buttons.map(b => (
						<button
							key={b.id}
							className='fv-modal-btn'
							onClick={() => onButton && onButton(b.id)}
						>
							{b.text}
						</button>
					))}
				</div>
			) : null}
		</div>
	</>
)

export default FinviseDialog
